import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../../mfe/MfeLoader";
import { getPoliciesHostConfig } from "../../config/policiesHostConfig";
import { useHostNavigate } from "../../hooks/useHostNavigate";

export const Route = createFileRoute("/policies/")({
  component: PoliciesPage,
});

function PoliciesPage() {
  const onNavigate = useHostNavigate();
  return (
    <MfeLoader
      name="policies"
      props={{ hostConfig: getPoliciesHostConfig(onNavigate) }}
    />
  );
}
